export default function FooterSection() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const links = [
    { label: '私たちについて', href: '#philosophy' },
    { label: '事業内容', href: '#business' },
    { label: '大切にしていること', href: '#values' },
    { label: '代表メッセージ', href: '#ceo-message' },
    { label: '会社概要', href: '#company' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  return (
    <footer className="bg-[#F0E8D8] py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10 mb-12">
          <div className="text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-4">
              <img
                src="https://static.readdy.ai/image/a3e3ca399326711c48a35eb0fed7f5ed/2215a3aed99dae2ff591f5f8f33940f6.png"
                alt="Hug ロゴ"
                className="h-12 w-auto object-contain"
              />
              <span
                className="text-lg font-medium text-[#3A2E28]"
                style={{ fontFamily: 'Noto Serif JP, serif' }}
              >
                Hug
              </span>
            </div>
            <p className="text-[#6B5E57] text-sm leading-relaxed max-w-xs">
              人の想いに寄り添い、<br />
              温もりのある社会をつくる。
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-3">
            <p className="text-[#A8835A] text-xs tracking-[0.2em] mb-2">NAVIGATION</p>
            {links.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-[#6B5E57] hover:text-[#3A2E28] transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-[#D8C8B0] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <p className="text-[#A8835A] text-xs tracking-widest">
              ベビー服事業
            </p>
          </div>
          <p className="text-[#A8835A] text-xs">
            &copy; 2026 Hug. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
